<!--Success message dialog-->
@if (data.status == 'uploadSuccess') {
  <div class="main-dialog">
    <div class="m-4">
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ data.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onClose()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

@if (data.status == 'success') {
  <div class="main-dialog">
    <div class="m-4">
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ data.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button class="btn-search btn" mode="primary" label="{{ 'label.common.okay' | translate }}" margin="xxsmall" mat-dialog-close></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!--Error message dialog-->
@if (data.status == 'error') {
  <div>
    <div id="dialogHeader" class="text-center p-0" [ngStyle]="data.colorBG">
      <label class="error-label">Error</label>
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          <span>{{ detail.message | translate }}</span>
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onClose()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!--Billing Error Message-->
@if (data.status == 'billingError') {
  <div>
    <div id="dialogHeader" class="text-center p-0" [ngStyle]="data.colorBG">
      <label class="error-label">Error</label>
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          <span>{{ detail.message | translate }}</span>
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onBillClose()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

@if (data.status == 'PersonalCreation') {
  <div>
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          <span>
            {{ 'label.group.contacts.createdSuccessfully' | translate }}
          </span>
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="btnOkContact()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!--submission of member details-->
@if (data.status == 'submission') {
  <div>
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          <span>
            {{ 'label.quotation.memberDetails.memberUpload' | translate }}
          </span>
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.quotation.memberDetails.okay' | translate }}"
            margin="xxsmall"
            (click)="btnSubmit()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!--Confirm dialog box-->
@if (data.status == 'confirmStatus') {
  <div>
    <div id="dialogHeader" class="text-center p-0">
      @if (!data.FlexibleContent) {
        <label class="confirm-label">{{ 'label.common.confirmation' | translate }}</label>
      }
      @if (data.FlexibleContent) {
        <label class="confirm-label">
          {{ data.FlexibleContent?.labelPopup | translate }}
        </label>
      }
    </div>
    <div class="m-4">
      @if (!data.FlexibleContent) {
        <div class="row text-center">
          <div class="col-12">
            <span>{{ data.message | translate }}</span>
          </div>
          <div class="col-12 mt-3">
            <custom-button
              class="btn-search btn"
              mode="primary"
              label="{{ 'label.common.yesContinue' | translate }}"
              margin="xxsmall"
              (click)="onSubmit()"
            ></custom-button>
            <custom-button
              class="btn-search btn"
              mode="text"
              label="{{ 'label.common.cancel' | translate }}"
              margin="xxsmall"
              (click)="onCancel()"
            ></custom-button>
          </div>
        </div>
      }
      <!-- For flexible type (input-text, date-picker,... ) -->
      @if (data.FlexibleContent) {
        <div class="row text-center">
          @if (data.FlexibleContent.typeField == 'datePicker') {
            <div class="col-12 flex-class">
              <custom-date-picker
                digitDate
                [placeholder]="true"
                label="{{ data.FlexibleContent.labelField | translate }}"
                (valueChange)="onChangeData($event, data.FlexibleContent.keyField)"
                (blur)="onDataBlur($event, data.FlexibleContent.keyField)"
                [model]="data.FlexibleContent.valueField"
                [errorMessage]="''"
              ></custom-date-picker>
            </div>
          }
          @if (data.FlexibleContent.typeField == 'checkbox') {
            <div class="col-12">
              <custom-checkbox
                labelPosition="after"
                label="{{ data.FlexibleContent.labelField | translate | translate }}"
                [checked]="data.FlexibleContent.valueField"
                (onChange)="onChangeData($event, data.FlexibleContent.keyField)"
              ></custom-checkbox>
            </div>
          }
          @if (!data.FlexibleContent.isFinalPopup) {
            <div class="col-12 mt-3">
              <custom-button
                class="btn-search btn"
                mode="primary"
                label="{{ 'label.common.yesContinue' | translate }}"
                margin="xxsmall"
                (click)="onSubmitFlexibleData(data.FlexibleContent.keyField)"
              ></custom-button>
              <custom-button
                class="btn-search btn"
                mode="text"
                label="{{ 'label.common.cancel' | translate }}"
                margin="xxsmall"
                (click)="onCancel()"
              ></custom-button>
            </div>
          }
          @if (data.FlexibleContent.isFinalPopup) {
            <div class="col-12 mt-3">
              <custom-button
                class="btn-search btn"
                mode="primary"
                label="{{ 'label.common.clone' | translate }}"
                margin="xxsmall"
                (click)="onSubmitFlexibleData(data.FlexibleContent.keyField)"
              ></custom-button>
            </div>
          }
        </div>
      }
      <!-- END For flexible type (input-text, date-picker,... ) -->
    </div>
  </div>
}

<!--Billing Summary Confirmation-->
@if (data.status == 'billConfirmation') {
  <div>
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          <span>
            <span>{{ data.message | translate }}</span>
          </span>
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseInfo()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!--Generate Quotation Bill Status-->
@if (data.status == 'generateQuoteBill') {
  <div>
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          <span>
            <span>{{ data.message | translate }}</span>
          </span>
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseInfo()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Success Message for Sharing PDF via Email. -->
@if (data.status == 'ShareEmail') {
  <div>
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          {{ 'label.insurerUW.successMessage' | translate }}
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onClose()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!-- send Message Success -->
@if (data.status == 'sendMessageSuccess') {
  <div>
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          {{ data.message }}
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseInfo()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!--Member UW History - Remarks - Confirmation Dialog-->

@if (data.status == 'confirmStatusRemarks') {
  <div>
    <div id="dialogHeader" class="text-center p-0">
      <label class="confirm-label">Confirmation</label>
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          <span>{{ data.message | translate }}</span>
        </div>
        <div class="col-12">
          <span>{{ data.confirmMessage | translate }}</span>
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.yesContinue' | translate }}"
            margin="xxsmall"
            (click)="onSubmit()"
          ></custom-button>
          <custom-button
            class="btn-search btn"
            mode="text"
            label="{{ 'label.common.cancel' | translate }}"
            margin="xxsmall"
            (click)="onCancel()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

@if (data.status == 'modifyClaimSuccess') {
  <div class="main-dialog">
    <div class="m-4">
      <div id="dialogHeader" class="text-center mt-3">
        <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
      </div>
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span> {{ 'label.claim.claimNo' | translate }}</span>
          <span> &nbsp;</span>
          <span class="color">{{ data.message | translate }}</span>
          <span> &nbsp;</span>
          <span> {{ 'label.claim.modifiedSuccessfully' | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseModifyClaimSuccess()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}
@if (data.status == 'createClaimSuccess') {
  <div class="main-dialog">
    <div class="m-4">
      <div id="dialogHeader" class="text-center mt-3">
        <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
      </div>
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span> {{ 'label.claim.claimNo' | translate }}</span>
          <span> &nbsp;</span>
          <span class="color">{{ data.message | translate }}</span>
          <span> &nbsp;</span>
          <span> {{ 'label.claim.createdSuccessfully' | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseCreateClaimSuccess()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Delete Confirmation - Dlete Claim Invoice - Delete Document-->
@if (data.status == 'deleteConfirmation') {
  <div>
    <div id="dialogHeader" class="text-center p-0">
      <label class="confirm-label">{{ 'label.common.confirmation' | translate }}</label>
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          <span>{{ data.confirmMessage | translate }}</span>
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.yes' | translate }}"
            margin="xxsmall"
            (click)="onSubmit()"
          ></custom-button>
          <custom-button class="btn-search btn" mode="text" label="{{ 'label.common.no' | translate }}" margin="xxsmall" (click)="onCancel()"></custom-button>
        </div>
      </div>
    </div>
  </div>
}

@if (data.status == 'createSuccess') {
  <div class="main-dialog">
    <div class="m-4">
      <div id="dialogHeader" class="text-center mt-3">
        <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
      </div>
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ detail.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseCreateSuccess()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}
@if (data.status == 'tpaSuccess') {
  <div class="main-dialog">
    <div class="m-4">
      <div id="dialogHeader" class="text-center mt-3">
        <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
      </div>
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ detail.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onClosetpaSuccess()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

@if (data.status == 'claimCreationSuccess') {
  <div class="main-dialog">
    <div class="m-4">
      <div id="dialogHeader" class="text-center mt-3">
        <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
      </div>
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span> {{ 'label.claim.claimRefNo' | translate }}</span>
          <span>&nbsp;</span>
          <span class="color">{{ data.message | translate }}</span>
          <span>&nbsp;</span>
          <span> {{ 'label.claim.createdSuccessfullyIC' | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseClaimCreation()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}
@if (data.status == 'claimDetailsSuccessfull') {
  <div class="main-dialog">
    <div class="m-4">
      <div id="dialogHeader" class="text-center mt-3">
        <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
      </div>
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ detail.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseClaimDetail()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Provider Organisation - Creation / Modification - Success Message. -->
@if (data.status == 'providerOrgCreateSuccess') {
  <div class="main-dialog">
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ data.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseProviderOrg()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Provider Organisation - Creation / Modifiaction - Failure Message. -->
@if (data.status == 'providerOrgCreateFail') {
  <div class="main-dialog">
    <div id="dialogHeader" class="text-center p-0" [ngStyle]="data.colorBG">
      <label class="error-label">Error</label>
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ data.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseProviderOrg()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

@if (data.status == 'providerLinkCreationSuccess') {
  <div class="main-dialog">
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ data.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseProviderLink()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

@if (data.status == 'providerOrgCreaModSuccess') {
  <div class="main-dialog">
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ data.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseproviderOrgCreaModSuccess()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Procedure, Drug and Medical Supplies - Creation / Modification - Success Message. -->
@if (data.status == 'drugMediacalSuccess') {
  <div class="main-dialog">
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ data.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseDrug()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!--Add Fee Schedule MEthod Success Message-->
@if (data.status == 'feeScheduleAddSuccessfully') {
  <div class="main-dialog">
    <div class="m-4">
      <div id="dialogHeader" class="text-center mt-3">
        <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
      </div>
      <div class="row text-center">
        <div class="col-xl-12 mt-3">
          <span>{{ detail.message | translate }}</span>
        </div>
        <div class="col-xl-12 btn-align mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseAddFeeSchedule()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Submit Success Message -->
@if (data.status == 'submitSuccess') {
  <div>
    <div id="dialogHeader" class="text-center mt-3">
      <img src="{{ tickIcon }}" alt="tick" />
    </div>
    <div class="m-4">
      <div class="row text-center">
        <div class="col-12">
          {{ data.message | translate: { dynamicData: data.dynamicData } }}
        </div>
        <div class="col-12 mt-3">
          <custom-button
            class="btn-search btn"
            mode="primary"
            label="{{ 'label.common.okay' | translate }}"
            margin="xxsmall"
            (click)="onCloseSubmit()"
          ></custom-button>
        </div>
      </div>
    </div>
  </div>
}
